import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { ProjectId } from 'api/models';
import { SpaceTab } from 'api/space/space-tab';
import { FetchStatus } from 'data/core';
import { saveSpaceTabs } from 'data/space-tabs';
import { useProjectSpacesQuery } from 'queries';
import { saveSpaces, Space } from '..';
import { spacesByProjectIdSelector } from '../selectors';

export const useProjectSpaces = (
  projectId: ProjectId,
): {
  data: Space[];
  isLoading: boolean;
  isError: boolean;
} => {
  const dispatch = useDispatch();
  const { isLoading, isError } = useProjectSpacesQuery(projectId, {
    onSuccess: (res) => {
      dispatch(
        saveSpaces({
          data: res.map((space) => ({
            ...space,
            project: { projectId: projectId[1], projectName: '' },
          })),
          fetchStatus: FetchStatus.Loaded,
        }),
      );
      dispatch(
        saveSpaceTabs({
          data: [
            ...res.reduce(
              (current, next) => [...current, ...next.spaceTabs],
              [] as SpaceTab[],
            ),
          ],
          fetchStatus: FetchStatus.Partial,
        }),
      );
    },
  });
  const spaces = useSelector(
    spacesByProjectIdSelector(projectId),
    shallowEqual,
  );

  return {
    data: spaces,
    isLoading,
    isError,
  };
};
